module.exports = __webpack_public_path__ + "static/media/security.6af04687.svg";